import {
  FETCH_LOCATION_BASED_REQUEST,
  FETCH_LOCATION_BASED_SUCCESS,
  FETCH_LOCATION_BASED_FAILURE,
} from "../constants/LocationBasedConstants";

import LocationBasedService from "../service/LocationBasedService";

export const fetchLocationBased = (date) => async (dispatch) => {
  try {
    dispatch({ type: FETCH_LOCATION_BASED_REQUEST });

    
    const data = await LocationBasedService.getAll(date);

    dispatch({
      type: FETCH_LOCATION_BASED_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: FETCH_LOCATION_BASED_FAILURE,
      payload:
        error.response?.data?.message || error.message || "Failed to fetch",
    });
  }
};
